<template>
  <div>
    <vsmallheader></vsmallheader>
    <div class="classbox">
      <div style="margin-top:20px;margin-bottom: 20px;display: flex;">
        <div style="font-size:14px;color:#888;display:flex;align-items: center">
          <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
          当前位置：
        </div>
        <span
          @click="retrun"
          style="cursor: pointer; font-size: 14px;"
        >调训管理/ {{trainInfoList.title}}</span>
      </div>
      <div class="classheader">
        <div class="classheader1">
          <div style="font-size:36px;color:#333">{{trainInfoList.title}}</div>
          <div class="task-right" v-if="trainInfoList.isenter && trainInfoList.timestatus==0">
            <div class="task-box" v-if="signUpState === false" @click="goSignUp" >立即报名</div>
            <div class="task-box" style="background-color: #f71010;" v-else-if="signUpState === true" @click="cancelSignUpFun">取消报名</div>
          </div>
        </div>
        <div class="classheader2">
          <div class="headerfirst">
            <div>
              培训方式：
              <span v-if="trainInfoList.createtype==1">线上培训</span>
              <span v-if="trainInfoList.createtype==2">线下培训</span>
            </div>
            <div>培训班类别：{{trainInfoList.cateDicName}}</div>
            <!-- <div>参训人员职级：科员</div> -->
            <div class="descript-title">
              培训主题：
              <span
                class="descript-text"
                :title="trainInfoList.descript"
                v-if="trainInfoList.descript"
              >{{trainInfoList.descript}}</span>
              <span v-else>无</span>
            </div>
          </div>
          <div class="headerfirst">
            <div>培训总人数：{{trainInfoList.peoplenum}}人</div>
            <div>承办部门（警种）：{{trainInfoList.jzDicName}}</div>
            <div>
              培训地点（基地）：
              <!-- <el-button
                type="text"
                v-for="(item,index) in baseInfoList"
                :key="index"
                class="hover-solid"
                @click="btnBase(item)"
              >{{item.basename}}</el-button> -->

              <el-button
                type="text"
            
               
                class="hover-solid"
                @click="btnBase(trainInfoList.baseids)"
              >{{trainInfoList.basenames}}</el-button>

              <span v-if="!trainInfoList.basenames">无</span>
            </div>
          </div>
          <div class="headerfirst">
            <div>培训时间：{{trainInfoList.startime}} 至 {{trainInfoList.endtime}}</div>

            <div>培训班层次：{{trainInfoList.classLevelName}}</div>
            <!-- <div>
              培训手册：
              <a
                v-if="trainInfoList.linkurl"
                class="dowload-href"
                :href="trainInfoList.linkurl"
                download
              >下载手册</a>
              <span v-else>无</span>
            </div>-->
          </div>
        </div>
      </div>

      <div class="classjindu">
        <span
          style="height: 80px;line-height: 80px; font-size: 24px; padding-right: 20px;color: #02a7f0; font-weight: bold;"
          class
        >培训班报名进度</span>
        <el-progress
          style="width: 960px;font-size: 38px;line-height: 75px;font-weight: bold;"
          :text-inside="true"
          :stroke-width="80"
          :percentage="trainInfoList.percentage"
          :color="customColors"
          :format="format"
        ></el-progress>
      </div>

      <div style="margin-top:30px;display:flex;">
        <div class="ageleft">
          <div class="lable">
            <div
              v-for="(item,index) in labledata"
              :key="index"
              :class="{heightlight : lableindex==index}"
              @click="lableArea(index,item)"
            >
              {{item}}
              <div v-if="lableindex==index" class="xian"></div>
            </div>
          </div>
          <div class="mettera" v-if="lableindex==0">
            <iframe
              v-if="trainInfoList.contents && !trainInfoList.linkurl"
              :src="pdfUrl"
              frameborder="0"
              width="1200"
              height="680"
            ></iframe>
            <a
              class="a-style"
              v-if="trainInfoList.linkurl && !trainInfoList.contents"
              target="view_window"
              :href="trainInfoList.linkurl"
            >链接：{{trainInfoList.linkurl}}</a>
            <nodata v-if="!trainInfoList.contents && !trainInfoList.linkurl"></nodata>
          </div>
          <div class="basenav" v-if="lableindex==1">
            <!-- :span-method="objectSpanMethod" -->
            <el-table :data="tableData" border height="440" style="width: 100%; ">
              <el-table-column min-width="300" prop="begintime" align="center" label="时间安排">
                <template slot-scope="scope">
                  <span>{{scope.row.begintime}} ~ {{scope.row.endtime}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="150" prop="name" align="center" label="主题"></el-table-column>
              <el-table-column prop="username" min-width="100" align="center" label="教官"></el-table-column>
              <el-table-column prop="address" min-width="150" align="center" label="地点"></el-table-column>
            </el-table>
          </div>
          <div class="basenav" v-if="lableindex==2">
            <courseList :trainId="trainId"></courseList>
          </div>
          <div class="basenav flex" v-if="lableindex==3">
            <div v-if=" !trainInfoList.issorece" class="timu-name">此培训班暂未公开</div>
            <el-table
              v-if="trainInfoList.issorece"
              height="550"
              ref="mainTable"
              :key="tableKey"
              :data="trainData"
              v-loading="listLoading"
              border
              fit
              highlight-current-row
              style="width: 100%;"
              :cell-style="{'text-align':'center'}"
            >
              <el-table-column type="index" min-width="80px" align="center"></el-table-column>

              <el-table-column min-width="50px" show-overflow-tooltip label="姓名" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column min-width="100px" show-overflow-tooltip label="警号" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.code}}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                class-name="status-col"
                show-overflow-tooltip
                align="center"
                :label="'工作单位'"
                min-width="130"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.unit}}</span>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                :label="item"
                :prop="item"
                min-width="100"
                v-for="(item,index) in getColumnName"
                :key="index"
              ></el-table-column>

              <!-- <el-table-column
                class-name="status-col"
                :label="'综合分数'"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{scope.row.score}}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                class-name="status-col"
                :label="'结果'"
                min-width="50"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag type="success" v-if="scope.row.state=='合格'">合格</el-tag>
                  <el-tag type="danger" v-else-if="scope.row.state=='不合格'">不合格</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 50px;" v-if=" trainInfoList.issorece">
              <el-pagination
                background
                prev-text="上一页"
                next-text="下一页"
                layout="total,prev, pager, next,jumper"
                :page-size="listQueryScore.Limit"
                :current-page.sync="listQueryScore.Page"
                :total="dataCountScore"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              ></el-pagination>
            </div>
          </div>
          <div class="basenav flex" v-if="lableindex==4">
            <nodata
              v-if="questionList.length<=0 && questionInfo.isOpen"
              style="padding-top: 200px;"
            ></nodata>

            <div v-if=" !questionInfo.isOpen" class="timu-name">此培训班暂未公开</div>

            <ul
              class="ul-box"
              v-for="(item,index) in questionList"
              :key="index"
              v-show="questionInfo.isOpen"
            >
              <li class="li-box no-line">
                <span class="title-biaoti">{{index+1}}.{{item.name}}</span>
              </li>
              <li class="li-box">
                <span class="li-title">选项</span>
                <span class="li-title">百分比</span>
                <span class="li-title">答题人数</span>
              </li>
              <li class="li-box" v-for="(items,indexs) in item.choiceList" :key="indexs">
                <span class="li-title" style="text-align: left;">{{items.name}}</span>
                <span class="li-title">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="26"
                    :percentage="items.percentage"
                    color="#1989fa"
                  ></el-progress>
                </span>
                <span class="li-title">{{items.count}}</span>
              </li>
              <li class="li-box" v-if="item.choiceList<=0">
                <span style="color: #C4C4CC; width: 100%;text-align: center;">暂无数据</span>
              </li>
            </ul>
          </div>

          <div class="basenav flex" v-if="lableindex==5">
            <div class="filter-container" style="display: flex;">
              <el-button type="primary" size="mini" @click="delBatch()">下载</el-button>
            </div>

            <el-table
              ref="JLTable"
              :data="TrainFileList"
              border
              style="width:100%;margin-top:10px"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" align="center" width="40"></el-table-column>
              <el-table-column min-width="80px" :label="'资料名称'" prop="name"></el-table-column>
              <el-table-column width="90px" :label="'类型'" prop="filetype" align="center"></el-table-column>
              <el-table-column width="100px" :label="'大小（M）'" prop="filesize" align="center"></el-table-column>
              <el-table-column width="140px" :label="'上传时间'" prop="publishtime" align="center"></el-table-column>
            </el-table>

            <div class>
              <el-pagination
                background
                prev-text="上一页"
                next-text="下一页"
                @current-change="handleCurrentChangeData"
                :current-page.sync="listQueryData.page"
                layout="total, prev, pager, next"
                :total="total1"
                v-if="total1>9"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="ageright">
          <div class="agerightheight">
            <div>近期报名</div>
          </div>
          <div style="background-color: #fff;padding:10px 0;">
            <nodata v-if="userList.length==0" style="margin-top: 50%;"></nodata>
            <div class="agerightanv" v-for="(item,index) in userList" :key="index">
              <img :src="item.photo" alt />
              <div>
                <div>{{item.name}}</div>
                <div
                  style="color:#7f7f7f;font-size:14px;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp:1;overflow: hidden;"
                  :title="item.deptName"
                >{{item.deptName}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="下发派送任务" :visible.sync="taskDialog" width="80%" center destroy-on-close>
      <DistributionTask ref="taskRef" v-if="taskDialog" :trainId="trainId"></DistributionTask>
      <span slot="footer" class="dialog-footer">
        <el-button @click="taskDialog = false">取 消</el-button>
        <el-button type="primary" @click="subUpdateTask">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="报送本单位人员" :visible.sync="onlineDialog" width="80%" center destroy-on-close>
      <TrainStaff ref="trainStaffRef" v-if="onlineDialog" :trainId="trainId"></TrainStaff>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onlineDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="testDialog" width="30%" center destroy-on-close :show-close="false">
      <div class="text-box">
        <div class="text-title" v-if="signUpFlag">
          <i class="el-icon-success" style="color: green; margin-right: 10px;"></i>
          <span>预报名成功</span>
        </div>
        <div class="text-title" v-if="!signUpFlag">
          <i class="el-icon-warning" style="color: #F7A610; margin-right: 10px;"></i>
          <span>{{signUpMessage}}</span>
        </div>
        <span class="text-tishi">温馨提示：</span>
        <span class="text-text">当前培训班准入测试通过的标准为学习积分达到 {{trainInfoList.learnscore}} 分；是否开始测试?</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="testNow">立即测试</el-button>
        <el-button type="info" @click="testDialog = false">返回</el-button>
      </span>
      <el-dialog
        width="40%"
        title="准入测试内容"
        :visible.sync="innerVisible"
        :show-close="false"
        center
        append-to-body
      >
        <TestContent v-if="innerVisible" :trainId="trainId"></TestContent>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" @click="innerVisible = false">返回</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- <linecom></linecom> -->
  </div>
</template>
<script>
import vsmallheader from '@/views/smallHeader/index';
import * as TrainApi from '@/api/train';
import * as news from '@/api/clientshome/index.js';
import * as voteApi from '@/api/vote/vote.js';
import courseList from './compoents/courseList';
import DistributionTask from './compoents/distributionTask';
import TrainStaff from './compoents/trainStaff';
import TestContent from './compoents/testContent';
import { getInfo } from '@/utils/auth';
import linecom from '@/components/linecom/index';
import { handleBatchDownload } from '@/utils/packdownload';

export default {
  components: {
    vsmallheader,
    courseList,
    DistributionTask,
    TrainStaff,
    TestContent,
    linecom,
  },
  data() {
    return {
      total1: 0,
      customColors: [
        { color: '#02a7f0', percentage: 20 },
        { color: '#02a7f0', percentage: 40 },
        { color: '#3fc194', percentage: 60 },
        { color: '#8be173', percentage: 80 },
        { color: '#a5eb61', percentage: 100 },
      ],
      tableKey: 0,
      labledata: [
        '培训班通知',
        '培训班日程',
        '培训班资源',
        '培训班成绩',
        '培训班评价',
        '培训班资料',
      ],
      trainInfoList: [],
      lableindex: 0,
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      listQueryScore: {
        page: 1,
        limit: 10,
        TrainId: this.$route.query.id,
      },
      listQueryData: {
        page: 1,
        limit: 9,
        TrainId: this.$route.query.id,
        isShow: true,
      },
      dataCountScore: 0,
      percentage: 0, //进度条进度
      htmlcontents: '',
      tableData: [],
      trainData: [],
      getColumnName: [],
      listLoading: true,
      questionList: [],
      questionInfo: {
        isOpen: false,
      },
      userList: [],
      taskDialog: false,
      onlineDialog: false,
      trainId: this.$route.query.id,
      testDialog: false,
      innerVisible: false,
      baseInfoList: [],
      signUpFlag: true,
      signUpMessage: '',
      pdfUrl: '',
      TrainFileList: [],
      multipleSelection: [],
      signUpState: null,
    };
  },
  created() {
    this.lableindex = this.$route.query.labelIndex
      ? this.$route.query.labelIndex
      : 0;
    this.getList();
    // this.getBaseInfo();
    // this.getmetter();
    this.getScheduleList();
    this.getTrainScore();
    this.getUserList();
    this.getIsSignUpFun();
  },
  methods: {
    //判断是否报名
    getIsSignUpFun(){
      let para = {
        trainId: this.$route.query.id,
        userId: this.$store.state.User.ids,
      };
      TrainApi.isSignUpApi(para).then(res=>{
        this.signUpState = res.result;
      })
    },
    //取消报名
    cancelSignUpFun(){
      this.$confirm('是否确认取消报名?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let para = {
          trainId: this.$route.query.id,
          userId: this.$store.state.User.ids,
        };
        TrainApi.delSignUpApi(para).then(res=>{
          if(!res.result){
            this.$message.error(res.message);
          }else{
            this.signUpState = !this.signUpState;
            this.$message.success('取消成功!');
            this.getUserList();
            this.getList();
          }
        })
      }).catch(() => {});
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //批量下载
    delBatch() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: '请选择至少一个',
          type: 'error',
        });
        return false;
      }
      let arry = [];
      //
      this.multipleSelection.forEach(function (item, index) {
        arry.push(item.fileurl);
      });

      handleBatchDownload(arry, this.trainInfoList.title);
    },
    //下载手册
    dowloadPdf() {
      let a = document.createElement('a');
      a.setAttribute('download', '培训手册');
      a.setAttribute('target', '_blank');
      a.setAttribute('href', this.trainInfoList.linkurl);
      a.click();
    },
    //点击基地名称
    btnBase(id) {
      this.$router.push({
        path: '/train/trainBase',
        query: {
          id: id,
        },
      });
    },
    // 获取培训资料
    TrainFile() {
      voteApi.TrainFileLoad(this.listQueryData).then((res) => {
        let data = res.data;
        this.total1 = res.count;
        // for (let i = 0; i < data.length; i++) {
        //   data[i].filesize = (Number(data[i].filesize) / 1024).toFixed(2) + 'M';
        // }
        this.TrainFileList = data;
      });
    },
    getBaseInfo() {
      TrainApi.getBaseInfo({ trainId: this.$route.query.id }).then((res) => {
        this.baseInfoList = res.result;
      });
    },
    //立即测试
    testNow() {
      // this.innerVisible = true;
      this.$router.push(
        `/personCenter/videoleam?trainid=${this.$route.query.id}`
      );
    },

    //确认下发任务
    subUpdateTask() {
      this.$refs.taskRef.updateTask();
      this.taskDialog = false;
    },
    //下发报送任务
    distributionTask() {
      this.taskDialog = true;
    },
    //确认人员
    submitUpdate() {
      this.$refs.trainStaffRef.updatePeople();
      this.onlineDialog = false;
    },
    //报送本单位人员
    reportPeople() {
      this.onlineDialog = true;
    },
    //立即报名
    goSignUp(){
      if (getInfo('tokens')) {
        this.$confirm('是否确认报名?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let para = {
            trainId: this.$route.query.id,
            userId: this.$store.state.User.ids,
          };
          TrainApi.signUp(para).then((res) => {
            this.signUpFlag = res.result;
            this.signUpMessage = res.message;
            if (res.result) {
              this.signUpState = !this.signUpState;
              this.$message.success(res.message);
            } else {
              this.$message.warning(res.message);
            }
            this.getUserList();
            this.getList();
          });
          if (this.trainInfoList.islearn) {
            this.testDialog = true;
          }
        });
      } else {
        window.clikLogin();
      }
    },
    getUserList() {
      let para = {
        trainId: this.$route.query.id,
        top: 10,
      };
      TrainApi.getLateUser(para).then((res) => {
        this.userList = res.result;
      });
    },
    getQuestionTJ() {
      let para = {
        topicId: this.trainInfoList.pollid,
      };
      voteApi.getQuestionTJ(para).then((res) => {
        this.questionList = res.result;
      });
      let para2 = {
        id: this.trainInfoList.pollid,
      };
      if (this.trainInfoList.pollid) {
        voteApi.getPollTopicModel(para2).then((res) => {
          this.questionInfo = res.result;
        });
      } else {
        this.questionInfo.isOpen = false;
      }
    },

    getTrainScore() {
      TrainApi.getUserScoreList(this.listQueryScore).then((res) => {
        this.trainData = res.data;
        this.dataCountScore = res.count;
      });
      TrainApi.getColumnName({ trainId: this.$route.query.id }).then((res) => {
        this.getColumnName = res.result;
      });
    },
    getScheduleList() {
      TrainApi.getScheduleList({ trainId: this.$route.query.id }).then(
        (res) => {
          this.tableData = res.data;
        }
      );
    },
    format() {
      return `${this.trainInfoList.cnt} / ${this.trainInfoList.peoplenum}`;
    },
    getList() {
      let para = {
        id: this.$route.query.id,
      };
      TrainApi.getDetail(para).then((res) => {
        this.trainInfoList = res.result[0];
        // console.log(this.trainInfoList)
        this.pdfUrl =
          '/pdf/web/viewer.html?file=' +
          encodeURIComponent(res.result[0].contents);
        // this.percentage=( res.result[0].cnt /  res.result[0].peoplenum)*100
        this.listLoading = false;
      });
    },
    retrun() {
      this.$router.go(-1);
    },
    lableArea(index, item) {
      this.lableindex = index;
      if (index == 4 || index == 3) {
        this.getQuestionTJ();
      } else if (index == 5) {
        this.TrainFile();
      }
    },
    // 分页组件的页数跳转方法
    handleSizeChange(val) {
      this.listQueryScore.limit = val;
      this.getTrainScore();
    },
    handleCurrentChange(val) {
      this.listQueryScore.page = val;
      this.getTrainScore();
    },
    handleCurrentChangeData(val) {
      this.listQueryData.page = val;
      this.TrainFile();
    },
  },
};
</script>
<style scoped>
.pageblock {
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
}
.classbox {
  margin: 0 auto;
  width: 1200px;
}
.classheader {
  padding: 20px;
  /* height: 260px; */
  box-shadow: rgba(215, 215, 215, 35%) 2px 2px 4px 1px;
  margin-bottom: 20px;
}
.classheader1 {
  display: flex;
  justify-content: space-between;
}

.task-right {
  display: flex;
}
.task-box {
  padding: 0 25px;
  border-radius: 5px;
  height: 46px;
  margin: 0 5px;
  line-height: 46px;
  font-size: 20px;
  cursor: pointer;
  color: #fff;
  background-color: rgb(247, 166, 16);
}
.classheader2 {
  display: flex;
}
.headerfirst {
  flex: 1;
}
.headerfirst > div {
  line-height: 50px;
  font-size: 16px;
  color: #333;
}
.classjindu {
  height: 130px;
  width: 1200px;
  margin: 0 auto;
  box-shadow: rgba(215, 215, 215, 35%) 2px 2px 5px 1px;
  padding: 0px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.ageleft {
  width: 900px;
  /* height: 200px; */
  background-color: #fff;
  box-shadow: rgba(215, 215, 215, 35%) 2px 2px 3px 2px;
}
.lable {
  width: 900px;
  height: 40px;
  border-bottom: solid 1px #f2f2f2;
  margin: 0 auto;
  padding-top: 10px;
  display: flex;
}
.lable > div {
  flex: 1;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  cursor: pointer;
}
.lable > div:hover {
  color: #409eff;
}
.heightlight {
  color: #409eff !important;
  font-weight: 700;
}
.xian {
  width: 150px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.ageright {
  width: 300px;
  margin-left: 30px;
  box-shadow: rgba(215, 215, 215, 35%) 2px 2px 5px 2px;
}
.agerightheight {
  height: 50px;
  background-color: #fff;

  display: flex;
  align-items: center;
}
.agerightheight > div:nth-child(1) {
  width: 160px;
  height: 20px;
  font-size: 18px;
  /* text-align: center; */
  padding-left: 20px;
  line-height: 20px;
  border-left: solid 5px #409eff;
  margin-left: 20px;
}
.agerightheight > div:nth-child(2) {
  width: 40px;
  height: 40px;
  text-align: center;
  /* line-height: 40px; */
  margin-left: 20px;
  border-radius: 5px;
  border: solid 1px orange;
  color: orange;
  background-color: rgb(255, 239, 221);
  /* background: linear-gradient(to right, rgb(245, 118, 0) , rgb(189, 161, 2))!important; */
}
.basenav {
  margin: 10px;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  /* text-align: center; */

  min-height: 500px;
  font-family: 'Arial Normal', 'Arial', sans-serif;
}
.flex {
  flex-direction: column;
}
.basenav-box {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 20px;
}
.basenav-box > span {
  padding-right: 5px;
  width: 280px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.agerightanv {
  display: flex;
}
.agerightanv > img {
  width: 95px;
  height: 95px;
  margin-left: 20px;
  background-color: #ccc;
  border-radius: 50%;
}
.agerightanv > div {
  line-height: 40px;
  font-size: 16px;
  padding: 10px;
  margin-left: 10px;
}
.mettera {
  width: 900px;
  min-height: 520px;
  line-height: 32px;
  margin: 0 auto;
  box-sizing: border-box;
  /* border-width: 1px;
    border-style: solid; */
  border-color: rgba(242, 242, 242, 1);
  border-radius: 5px;
  padding-bottom: 30px;
  padding: 10px;
  display: flex;
  justify-content: center;
  /* align-items: center; */
  padding-top: 20px;
}
/* 问卷 */
.timu-name {
  color: #c4c4cc;
  line-height: 220px;
  font-size: 20px;
  /* font-weight: 700; */
  padding: 10px 0;
}
.li-box {
  display: flex;
  /* height: 40px;
    line-height: 40px; */
  padding: 10px 0;
  border-bottom: 1px solid rgba(215, 215, 215, 0.968627450980392);
}
.no-line {
  border-bottom: none;
  padding: 10px 0;
}
.li-title {
  width: 50%;
  /* padding: 10px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.title-biaoti {
  font-size: 18px;
  font-weight: 500;
}
/* 报名弹框 */
.text-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 40px;
}
.text-title {
  font-size: 20px;
  padding-bottom: 10px;
}
.text-tishi {
  font-size: 16px;
  color: #48bff4;
}
.text-text {
  font-size: 16px;
}
.descript-title {
  width: 370px;
  display: flex;
  white-space: nowrap;
}
.descript-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hover-solid:hover {
  text-decoration: underline;
}
.dowload-href:hover {
  text-decoration: underline;
  color: rgb(64, 158, 255);
}
.dowload-href {
  font-size: 16px;
  color: #333;
}
.a-style {
  color: rgb(64, 158, 255);
  cursor: pointer;
}
.a-style:hover {
  text-decoration: underline;
}

/deep/.el-progress-bar__innerText {
  font-size: 20px !important;
}
/deep/.el-progress-bar__inner,
/deep/.el-progress-bar__outer {
  border-radius: 0;
  border-radius: 0 8px 8px 0;
}
</style>